import React from "react";
import "./Insurance.css";

const insuranceData = [
  {
    title: "Life Insurance",
    text: "Life insurance is a financial protection plan that provides financial security to your family in case of the policyholder’s death. It ensures that your loved ones can maintain their lifestyle and meet future expenses even in your absence. You pay a small amount (premium) regularly to an insurance company. In return, the insurer pays a lump sum amount (sum assured) to your nominee if something happens to you during the policy term.",
    icon: "/icons/z1.png"
  },
  {
    title: "Health Insurance",
    text: "Health insurance is a financial protection plan that covers medical and hospitalization expenses, helping you manage healthcare costs without financial stress.You pay a regular premium to an insurance company. In return, the insurer pays for your hospital bills, treatments, surgeries, and medical expenses as per the policy terms.",
    icon: "/icons/z3.png"
  },
  {
    title: "General Insurance",
    text: "General insurance provides financial protection against losses or damages other than life, helping individuals and businesses manage unexpected risks.You pay a premium to an insurance company. In return, the insurer compensates you for financial losses caused by accidents, theft, fire, natural disasters, or other covered events.",
    icon: "/icons/z2.png"
  },
  {
    title: "Term Insurance",
    text: "Term insurance is a pure life insurance plan that provides high financial protection at a very low cost for a specific period (term).You pay a small premium for a fixed number of years. If the policyholder passes away during the policy term, the insurance company pays the sum assured to the nominee. If the policy term ends and the policyholder is alive, no maturity benefit is paid.",
    icon: "/icons/z4.png"
  },
  {
    title: "Child Insurance",
    text: "Child insurance is a financial plan designed to secure a child’s future, especially for education, marriage, and long-term goals, even if something happens to the parent.Parents pay premiums to an insurance company. The policy provides financial support for the child’s future milestones, and in case of the parent’s untimely death, the insurer continues the policy and pays benefits to the child.",
    icon: "/icons/z5.png"
  },
  {
    title: "Pension Plan",
    text: "A pension plan is a long-term financial plan that helps you build a regular income after retirement, ensuring financial independence and a comfortable lifestyle in your non-working years.You invest (pay premiums) during your earning years. After retirement, the plan provides regular income (pension/annuity) to meet daily expenses, while some plans also offer a lump sum benefit.",
    icon: "/icons/z6.png"
  }
];

export default function Insurance() {
  return (
       <section className="insurance-section" id="insurance">
      <h2 className="insurance-heading">Insurance</h2>

      <div className="insurance-grid">
        {insuranceData.map((item, i) => (
          <div className="insurance-card" key={i}>
            <img src={item.icon} alt={item.title} className="card-icon" />
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
